import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import Menu from '../../../baseComponents/MenuButton'
import { getUrl } from '../../../utils/routesDefinition'
import Grid from '../../../baseComponents/HeaderGrid'
import Logo from '../../../baseComponents/Logo'

const items = {
  6: [
    { x: 0, y: 0, w: 1, h: 1, component: 'Logo' },
    { x: 1, y: 0, w: 3, h: 1, component: 'Title' },
    { x: 4, y: 0, w: 1, h: 1, component: 'Search' },
    { x: 5, y: 0, w: 1, h: 1, component: 'Menu' },
  ],
  4: [
    { x: 0, y: 0, w: 1, h: 1, component: 'Logo' },
    { x: 1, y: 0, w: 1, h: 1, component: 'Search' },
    { x: 2, y: 0, w: 1, h: 1, component: 'Title' },
    { x: 3, y: 0, w: 1, h: 1, component: 'Menu' }
  ],
  1: [
    { x: 0, y: 0, w: 1, h: 1, component: null },
  ]
}

const Search = props => <Link className='centered header-close' to={getUrl('summer')}>
  <span className="icon-search-04"></span>
</Link>


const Title = props => <div className={`centered animated-text ${props.isScrollActive ? 'in' : ''}`} data-title='SOMA SUMMER' style={{ background: props.appState.colorTheme.level1 }}>
  <h1 className='header-title header-fix'>SOMA SUMMER</h1>
</div>

const getComponent = (component, props) => {
  if (component === null) return component
  switch (component) {
    case 'Logo': return <Logo isScrollActive={props.isScrollActive} />
    case 'Search': return <Search {...props} />
    case 'Title': return <Title {...props} />
    case 'Menu': return <Menu />
    default: return null
  }
}


const header = props => <Grid isScrollActive={props.isScrollActive}>
  {
    items[props.appState.headerItem].map((item, index) => <div
      className='header-item'
      style={{ background: props.appState.colorTheme.base }}
      key={index} values={{ x: item.x, y: item.y, w: item.w, h: item.h }}>
      {getComponent(item.component, { ...props, ...item })}
    </div>)
  }
</Grid>

const mapStateToProps = state => ({
  appState: state.appState
})

export default connect(mapStateToProps)(header)
